document.addEventListener("DOMContentLoaded", function () {
  try {
    
 
  const parentBtns = document.querySelectorAll(".parent__btn");
  //console.log(parentBtns)

  if (parentBtns.length === 0) {
    console.log("Can't  found parent elements for mobile nav");
    return;
  }

  parentBtns.forEach((parent) => parent.addEventListener('click', handleClick));

  function handleClick(e) {

    // sale link
    /*if(e.currentTarget.dataset.parent === 'sale'){
      window.location = '/collections/walking-canes-on-sale'
      return;
    }*/
  
    // previous clicked elements
    const prev = document.querySelectorAll('.menu-link__container .show')
    prev?.forEach(el => el?.classList?.remove('show'))
    
    const el = e.currentTarget
    el.classList.toggle("open")
    console.log(e)
    const child = e.currentTarget.nextElementSibling
   
    if(!child){
      console.log("No child elements for parent element.")
      return;
    }
      
    child.classList.toggle('show')


    //2nd level show
     const parent = e.currentTarget.dataset.parent
      //console.log(parent)
     const secondLevelEl = document.querySelector(`.child.show[data-nested='${parent}']:has(.grandchild)`);

    if (!secondLevelEl) {
      console.log("Can't found 2nd level parent elements for mobile nav");
      return;
    }
    //console.log(secondLevelEl)

    secondLevelEl.classList.toggle('show-second-level')

    
    //2nd level heading
    const secondLevelContainer = document.querySelector('.second-level-heading')
    const secondLevelHeading = document.querySelector('[data-js="second-level-heading"]')
    const title = parent.replace(/-/g, " ")
    secondLevelHeading.innerText = title ;
    secondLevelContainer.classList.toggle('show')

    // 2nd level open li
    const openedSecoldLevelChilds = document.querySelectorAll(`.child.show.show-second-level > li`);
     if (openedSecoldLevelChilds.length === 0) {
      console.log("Can't  found openedSecoldLevelChilds elements for mobile nav");
      return;
    }
    //console.log(openedSecoldLevelChilds)
    
    openedSecoldLevelChilds.forEach(el => el.addEventListener('click', (e)=>{
      const target = e.currentTarget

      const prevTarget = document.querySelectorAll('.show-second-level .selected')
      prevTarget?.forEach(el => el?.classList?.remove('selected'))
      const prevFirst = document.querySelector('.show-second-level .open-first')
      if(prevFirst){
        prevFirst.classList?.remove('open-first')
      }
    
      target.classList.toggle("selected")
      
      const sibling = e.target.nextElementSibling
      //console.log(sibling)
      
      if(!sibling){
        console.log("Can't found 2nd level sibling elements for mobile nav");
        return;
      }

      const prev = document.querySelectorAll('.show-second-level .show')
      //console.log(prev)
      prev?.forEach(el => el?.classList?.remove('show'))
      
      sibling.classList.add('show')
    }))

    // open first second level - all walking canes > popular
     const firstEl = document.querySelector('.show-second-level li')
     if(!firstEl){
        console.log("Can't found 2nd level firstEl element for mobile nav");
        return;
      }
    firstEl.classList.add('open-first')
    firstEl.children[1].classList.add('show')

  }

  // 2nd level back button
  const secondLevelBackBtn = document.querySelector("[data-js='mobile-back-menu-btn']");

   if (!secondLevelBackBtn) {
    console.log("Can't found 2nd level secondLevelBackBtn for mobile nav");
    return;
  }

  secondLevelBackBtn.addEventListener('click', handleSecondBackBtn);

   function handleSecondBackBtn(e) {
     //console.log("2nd back", e.target);

     const secondLevelContainer = document.querySelector('.second-level-heading')
     secondLevelContainer.classList.toggle('show')

     const secondLevelEl = document.querySelector(`.child.show.show-second-level`);
      secondLevelEl.classList.toggle('show-second-level')

    // second level, activated
     setTimeout(()=>{
       const prevSecond = document.querySelectorAll('.selected')
     
       if (prevSecond.length !== 0) {
        console.log("prev selected", prevSecond);
         prevSecond.forEach(el => el.classList.remove('selected'))
       }
     },300)

     // toggle first button
     const parentBtns = document.querySelectorAll(".parent__btn");

      if (parentBtns.length === 0) {
        console.log("Can't  found back parent elements for mobile nav");
        return;
      }

     parentBtns[0].click()

   }

  // Navigation hamburger icon
  const mobileMenuIcon = document.querySelector('[data-js-mobile-menu]')

   if (!mobileMenuIcon) {
    console.log("Can't found mobileMenuIcon element ");
    return;
  }

  mobileMenuIcon.addEventListener('click', handleClose)

  // Opened mobile menu
  const mobileMenuClose = document.querySelector('.mobile-nav [data-js-popup-close]')

  if(mobileMenuClose){    
    mobileMenuClose.addEventListener('click', handleClose)
  }

   function handleClose(e){
    e.preventDefault()
   
    const popupPrev = document.querySelector('.popup.js-popup.active')
    if(popupPrev){
      popupPrev.setAttribute('tabindex', '0')
    }

    const popupContainer = document.querySelector('.popup.js-popup')
    const popupBg = document.querySelector('.popup__bg')
    const popupBody = document.querySelector('.popup__body')
    const content = document.querySelector('.mobile-menu__container')

   

    popupContainer.classList.toggle('active')
    popupContainer.classList.toggle('show')
    popupContainer.setAttribute('tabindex', '10')
    
    content.classList.toggle('animate-active')

    popupBg.classList.toggle('visible')
    
    popupBody.classList.toggle('show')
    popupBody.classList.toggle('visible')

  }

  // Opened mobile menu backdrop - FIX THIS: listener not working
  const mobileMenuBackdrop = document.querySelector('.mobile-nav [data-js-backdrop]')
  
  if(!mobileMenuBackdrop){
    console.log("Can't found mobileMenuBackdrop element ");
    return;
  }
  console.log("mobileMenuBackdrop", mobileMenuBackdrop)
  mobileMenuBackdrop.addEventListener('click', handleClose)
  
   } catch (error) {
    console.error(error)
  }

 

  


});
